// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"718":"9482e2ed","945":"9482e2ed"}[chunkId] + ".chunk.css";
};